import PropTypes from 'prop-types';

export default {
  captions: PropTypes.bool,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  dropdown: PropTypes.bool,
  id: PropTypes.string,
  element: PropTypes.string,
  inversed: PropTypes.bool,
  larger: PropTypes.bool,
  to: PropTypes.string,
  pale: PropTypes.bool,
  paleFine: PropTypes.bool,
  pushRight: PropTypes.bool,
  preloaderColor: PropTypes.string,
  primary: PropTypes.bool,
  fine: PropTypes.bool,
  readOnly: PropTypes.bool,
  secondary: PropTypes.bool,
  sharp: PropTypes.bool,
  showPreloader: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipId: PropTypes.string,
  tooltipPlacement: PropTypes.string,
  transparent: PropTypes.bool,
  uppercase: PropTypes.bool,
};
